import { Div } from '../../../../base/components/native/div'
import emitter from '../../../../base/utils/emitter'
import { AssistantSelectorSubject } from './asistant-selector-subject'
import { AssistantSelectorButton } from './assistant-selector-button'

export const AssistantSelector = () => {

    const base = Div()
    const title = Div('I want to create a')
    const typeButton = AssistantSelectorButton()
    const subject = AssistantSelectorSubject()
    const feeling = Div(' feeling ')
    const feelingsButton = AssistantSelectorButton()
    base.append(title, typeButton, subject, feeling, feelingsButton)

    subject.on('input', (e: any) => {
        feeling.style({ display: 'flex' })
        feelingsButton.style({ display: 'flex' })
    })
    typeButton.el.onclick = () => base.emit('assistant-selector-type', 'type')
    feelingsButton.el.onclick = () => base.emit('assistant-selector-type', 'feelings')
    feeling.cssClass({
        display: 'none',
    })
    base.cssClass({
        height: '37px',
        fontSize: '20px',
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        overflow: 'hidden',
        overflowX: 'auto',
        paddingRight: '30px',
    })

    return Object.assign(base, {
        apply: (data: { type: string, title: string }) => {
            switch (data.type) {
                case 'type':
                    typeButton.style({ display: 'flex' })
                    typeButton.setTitle(data.title)
                    subject.style({ display: 'flex' })
                    subject.focus()
                    break
                case 'feelings':
                    feelingsButton.style({ display: 'flex' })
                    feelingsButton.setTitle(data.title)
            }
        },
        getValue: () => {
            return 'I want to create a ' + typeButton.el.innerText + ' of a ' + subject.getValue() + ' feeling ' + feelingsButton.el.innerText
        }
    })
}